import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { doDeleteOpeningById, openCloseModalDeleteOpening } from "./actions";
import OpeningValidation from "./wizard/openigValidation";

class ModalDeleteOpening extends React.PureComponent {
  handleClose = () => {
    this.props.dispatch(openCloseModalDeleteOpening(false, null));
  }

  handleDelete = () => {
    this.props.dispatch(doDeleteOpeningById(this.props.idOpeningToDelete));
  }
  renderDeleteMessege = () => (
    <div>
      {this.props.isLoading && <LoadingOverlay />}

      <div className="text-center" style={{ marginTop: 20 }}>
        ¿Quieres eliminar la apertura?
      </div>
      <div className="button-row">
        <div>
          <Button
            text="Cancelar"
            onClick={this.handleClose}
          />
        </div>
        <div>
          <Button
            text="Eliminar"
            type="danger"
            onClick={this.handleDelete}
          />
        </div>
      </div>
    </div>
  )


  render() {
    const {
      validationOpening,
    } = this.props;
    return (
      <Popup
        visible={this.props.isOpenModalDeleteOpening}
        title="Eliminar apertura"
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
        height={250}
        width={550}
      >
        <div>
          {
            validationOpening.openValidation === false ? this.renderDeleteMessege() : <OpeningValidation />

          }
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.aperturasSel.isLoading,
  idOpeningToDelete: state.aperturasSel.idOpeningToDelete,
  isOpenModalDeleteOpening: state.aperturasSel.isOpenModalDeleteOpening,
  validationOpening: state.aperturasSel.validationOpening,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDeleteOpening);
